// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === WST-Logo: zwei Animations-Varianten === */

.AnimatedLogo_logo__2-olB {
  fill: none;
  stroke: url(#wstGradient);
  stroke-width: 7;
  stroke-linecap: round;
  stroke-linejoin: round;
  filter: drop-shadow(0 0 6px rgba(74, 158, 255, 0.45));
}

/* ============================================
   Variante 1: SCAFFOLD (initialer Seitenload)
   Buchstaben zeichnen sich Linie fuer Linie per stroke-dash-offset.
   ============================================ */

.AnimatedLogo_animated__Q28bW .AnimatedLogo_letter__zJmKF {
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  animation: AnimatedLogo_scaffoldDraw__0Xiif 3.6s cubic-bezier(0.65, 0, 0.35, 1) infinite;
}

/* Stagger W -> S -> T */
.AnimatedLogo_animated__Q28bW .AnimatedLogo_letterW__IQVTl { animation-delay: 0s; }
.AnimatedLogo_animated__Q28bW .AnimatedLogo_letterS__gcg6B { animation-delay: 0.18s; }
.AnimatedLogo_animated__Q28bW .AnimatedLogo_letterT__vHobR { animation-delay: 0.36s; }

@keyframes AnimatedLogo_scaffoldDraw__0Xiif {
  0%   { stroke-dashoffset: 100; }
  35%  { stroke-dashoffset: 0; }
  55%  { stroke-dashoffset: 0; }
  90%  { stroke-dashoffset: 100; }
  100% { stroke-dashoffset: 100; }
}

/* ============================================
   Variante 2: BUILDER (Modal-Loadings) - RTS-Gebaeude-Bau
   Buchstaben bestehen aus einzelnen Bauteilen (Strichen). Jedes Bauteil
   fliegt von seiner Start-Position (bx/by + Rotation br) an seinen Platz,
   setzt sich zusammen, haelt, und fliegt beim Abbau in eine andere
   Richtung (dx/dy + Rotation dr) auseinander. Endlos-Loop mit Stagger.
   ============================================ */

.AnimatedLogo_brick__fxQ9T {
  transform-box: fill-box;
  transform-origin: center;
  opacity: 0;
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  filter: drop-shadow(0 0 5px rgba(74, 158, 255, 0.6));
}

/* Pro Buchstabe: Start-Vektor (bx/by/br) + Disperse-Vektor (dx/dy/dr) + Stagger */
.AnimatedLogo_animated__Q28bW .AnimatedLogo_brickW__uNXIE { animation-delay: 0s;    --bx:-30px; --by:40px;  --br:-25deg; --dx:-40px; --dy:60px;  --dr:-35deg; }
.AnimatedLogo_animated__Q28bW .AnimatedLogo_brickS__-7UzZ { animation-delay: 0.2s;  --bx:40px;  --by:-35px; --br:20deg;  --dx:50px;  --dy:-50px; --dr:30deg;  }
.AnimatedLogo_animated__Q28bW .AnimatedLogo_brickT__W-uBp { animation-delay: 0.4s;  --bx:35px;  --by:45px;  --br:15deg;  --dx:45px;  --dy:60px;  --dr:25deg;  }

.AnimatedLogo_animated__Q28bW .AnimatedLogo_brick__fxQ9T {
  animation: AnimatedLogo_rtsBuild__wj00d 4s cubic-bezier(0.5, 0.05, 0.3, 1) infinite;
}

@keyframes AnimatedLogo_rtsBuild__wj00d {
  /* Start: verschoben, rotiert, unsichtbar, stroke komplett versteckt */
  0% {
    transform: translate(var(--bx, 0), var(--by, 0)) rotate(var(--br, 0deg));
    opacity: 0;
    stroke-dashoffset: 100;
  }
  6%  { opacity: 0.5; stroke-dashoffset: 100; }
  10% { opacity: 1; stroke-dashoffset: 70; }
  /* Angekommen + zusammengebaut: an Position, stroke komplett gezeichnet */
  22%, 60% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 1;
    stroke-dashoffset: 0;
  }
  /* Abbau: fliegt weg + loest sich auf */
  80% {
    transform: translate(var(--dx, 0), var(--dy, 0)) rotate(var(--dr, 0deg));
    opacity: 0;
    stroke-dashoffset: 100;
  }
  /* Pause-Phase: reset */
  100% {
    transform: translate(var(--bx, 0), var(--by, 0)) rotate(var(--br, 0deg));
    opacity: 0;
    stroke-dashoffset: 100;
  }
}

@media (prefers-reduced-motion: reduce) {
  .AnimatedLogo_animated__Q28bW .AnimatedLogo_letter__zJmKF,
  .AnimatedLogo_animated__Q28bW .AnimatedLogo_brick__fxQ9T {
    animation: none;
    stroke-dashoffset: 0;
    opacity: 1;
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AnimatedLogo.module.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;EACE,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;;;iDAGiD;;AAEjD;EACE,qBAAqB;EACrB,sBAAsB;EACtB,wFAAoE;AACtE;;AAEA,wBAAwB;AACxB,6DAAqB,mBAAmB,EAAE;AAC1C,6DAAqB,sBAAsB,EAAE;AAC7C,6DAAqB,sBAAsB,EAAE;;AAE7C;EACE,OAAO,sBAAsB,EAAE;EAC/B,OAAO,oBAAoB,EAAE;EAC7B,OAAO,oBAAoB,EAAE;EAC7B,OAAO,sBAAsB,EAAE;EAC/B,OAAO,sBAAsB,EAAE;AACjC;;AAEA;;;;;;iDAMiD;;AAEjD;EACE,uBAAuB;EACvB,wBAAwB;EACxB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA,kFAAkF;AAClF,4DAAoB,mBAAmB,KAAK,UAAU,EAAE,SAAS,GAAG,WAAW,EAAE,UAAU,EAAE,SAAS,GAAG,WAAW,EAAE;AACtH,4DAAoB,qBAAqB,GAAG,SAAS,GAAG,UAAU,EAAE,UAAU,GAAG,SAAS,GAAG,UAAU,EAAE,UAAU,GAAG;AACtH,4DAAoB,qBAAqB,GAAG,SAAS,GAAG,SAAS,GAAG,UAAU,GAAG,SAAS,GAAG,SAAS,GAAG,UAAU,GAAG;;AAEtH;EACE,mFAA+D;AACjE;;AAEA;EACE,sEAAsE;EACtE;IACE,wEAAwE;IACxE,UAAU;IACV,sBAAsB;EACxB;EACA,MAAM,YAAY,EAAE,sBAAsB,EAAE;EAC5C,MAAM,UAAU,EAAE,qBAAqB,EAAE;EACzC,yEAAyE;EACzE;IACE,uCAAuC;IACvC,UAAU;IACV,oBAAoB;EACtB;EACA,uCAAuC;EACvC;IACE,wEAAwE;IACxE,UAAU;IACV,sBAAsB;EACxB;EACA,uBAAuB;EACvB;IACE,wEAAwE;IACxE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,oBAAoB;IACpB,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":["/* === WST-Logo: zwei Animations-Varianten === */\n\n.logo {\n  fill: none;\n  stroke: url(#wstGradient);\n  stroke-width: 7;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  filter: drop-shadow(0 0 6px rgba(74, 158, 255, 0.45));\n}\n\n/* ============================================\n   Variante 1: SCAFFOLD (initialer Seitenload)\n   Buchstaben zeichnen sich Linie fuer Linie per stroke-dash-offset.\n   ============================================ */\n\n.animated .letter {\n  stroke-dasharray: 100;\n  stroke-dashoffset: 100;\n  animation: scaffoldDraw 3.6s cubic-bezier(0.65, 0, 0.35, 1) infinite;\n}\n\n/* Stagger W -> S -> T */\n.animated .letterW { animation-delay: 0s; }\n.animated .letterS { animation-delay: 0.18s; }\n.animated .letterT { animation-delay: 0.36s; }\n\n@keyframes scaffoldDraw {\n  0%   { stroke-dashoffset: 100; }\n  35%  { stroke-dashoffset: 0; }\n  55%  { stroke-dashoffset: 0; }\n  90%  { stroke-dashoffset: 100; }\n  100% { stroke-dashoffset: 100; }\n}\n\n/* ============================================\n   Variante 2: BUILDER (Modal-Loadings) - RTS-Gebaeude-Bau\n   Buchstaben bestehen aus einzelnen Bauteilen (Strichen). Jedes Bauteil\n   fliegt von seiner Start-Position (bx/by + Rotation br) an seinen Platz,\n   setzt sich zusammen, haelt, und fliegt beim Abbau in eine andere\n   Richtung (dx/dy + Rotation dr) auseinander. Endlos-Loop mit Stagger.\n   ============================================ */\n\n.brick {\n  transform-box: fill-box;\n  transform-origin: center;\n  opacity: 0;\n  stroke-dasharray: 100;\n  stroke-dashoffset: 100;\n  filter: drop-shadow(0 0 5px rgba(74, 158, 255, 0.6));\n}\n\n/* Pro Buchstabe: Start-Vektor (bx/by/br) + Disperse-Vektor (dx/dy/dr) + Stagger */\n.animated .brickW { animation-delay: 0s;    --bx:-30px; --by:40px;  --br:-25deg; --dx:-40px; --dy:60px;  --dr:-35deg; }\n.animated .brickS { animation-delay: 0.2s;  --bx:40px;  --by:-35px; --br:20deg;  --dx:50px;  --dy:-50px; --dr:30deg;  }\n.animated .brickT { animation-delay: 0.4s;  --bx:35px;  --by:45px;  --br:15deg;  --dx:45px;  --dy:60px;  --dr:25deg;  }\n\n.animated .brick {\n  animation: rtsBuild 4s cubic-bezier(0.5, 0.05, 0.3, 1) infinite;\n}\n\n@keyframes rtsBuild {\n  /* Start: verschoben, rotiert, unsichtbar, stroke komplett versteckt */\n  0% {\n    transform: translate(var(--bx, 0), var(--by, 0)) rotate(var(--br, 0deg));\n    opacity: 0;\n    stroke-dashoffset: 100;\n  }\n  6%  { opacity: 0.5; stroke-dashoffset: 100; }\n  10% { opacity: 1; stroke-dashoffset: 70; }\n  /* Angekommen + zusammengebaut: an Position, stroke komplett gezeichnet */\n  22%, 60% {\n    transform: translate(0, 0) rotate(0deg);\n    opacity: 1;\n    stroke-dashoffset: 0;\n  }\n  /* Abbau: fliegt weg + loest sich auf */\n  80% {\n    transform: translate(var(--dx, 0), var(--dy, 0)) rotate(var(--dr, 0deg));\n    opacity: 0;\n    stroke-dashoffset: 100;\n  }\n  /* Pause-Phase: reset */\n  100% {\n    transform: translate(var(--bx, 0), var(--by, 0)) rotate(var(--br, 0deg));\n    opacity: 0;\n    stroke-dashoffset: 100;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .animated .letter,\n  .animated .brick {\n    animation: none;\n    stroke-dashoffset: 0;\n    opacity: 1;\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `AnimatedLogo_logo__2-olB`,
	"animated": `AnimatedLogo_animated__Q28bW`,
	"letter": `AnimatedLogo_letter__zJmKF`,
	"scaffoldDraw": `AnimatedLogo_scaffoldDraw__0Xiif`,
	"letterW": `AnimatedLogo_letterW__IQVTl`,
	"letterS": `AnimatedLogo_letterS__gcg6B`,
	"letterT": `AnimatedLogo_letterT__vHobR`,
	"brick": `AnimatedLogo_brick__fxQ9T`,
	"brickW": `AnimatedLogo_brickW__uNXIE`,
	"brickS": `AnimatedLogo_brickS__-7UzZ`,
	"brickT": `AnimatedLogo_brickT__W-uBp`,
	"rtsBuild": `AnimatedLogo_rtsBuild__wj00d`
};
export default ___CSS_LOADER_EXPORT___;
